export const router = {
  path: "youyueServe",
  name: "youyueServe",
  meta: {
    title: "优越服务",
    title_en: "SERVICE",
    showOnNavMenu: true,
    navMenuMode: "custom",
    iconfont: "icon-chanpin",
    dropDown: true,
    subBar: true,
  },
  redirect() {
    return { name: "foodSupply" };
  },
  children: [
    {
      path: "foodSupply",
      name: "foodSupply",
      meta: {
        title: "食品产业供应链",
        dropDown: false,
        showOnNavMenu: true,
      },
      component: () => import("@/views/serve/foodSupply/index.vue"),
    },
    {
      path: "technology",
      name: "technology",
      meta: {
        title: "先进技术成果",
        showOnNavMenu: true,
      },
      component: () => import("@/views/serve/technology/index.vue"),
    },
    {
      path: "solution",
      name: "solution",
      meta: {
        title: "行业痛点解决方案",
        showOnNavMenu: true,
        dropDown: true,
      },
      redirect() {
        return { name: "brandServe" };
      },
      children: [
        {
          path: "brandServe",
          name: "brandServe",
          meta: {
            title: "全品牌规划服务",
            showOnNavMenu: true,
          },
          component: () => import("@/views/serve/brandServe/index.vue"),
        },
        {
          path: "developmentServices",
          name: "developmentServices",
          meta: {
            title: "关键技术支撑服务",
            showOnNavMenu: true,
          },
          component: () =>
            import("@/views/serve/developmentServices/index.vue"),
        },
        {
          path: "smartManufacturing",
          name: "smartManufacturing",
          meta: {
            title: "工业互联/ERP开发服务",
            showOnNavMenu: true,
          },
          component: () =>
            import("@/views/serve/smartManufacturing/index.vue"),
        },
        {
          path: "intelligentServices",
          name: "intelligentServices",
          meta: {
            title: "先进智能智造服务",
            showOnNavMenu: true,
          },
          component: () =>
            import("@/views/serve/intelligentServices/index.vue"),
        },
        {
          path: "foodSafe",
          name: "foodSafe",
          meta: {
            title: "质量监控快检服务",
            showOnNavMenu: true,
          },
          component: () => import("@/views/serve/foodSafe/index.vue"),
        },
        {
          path: "talentTraining",
          name: "talentTraining",
          meta: {
            title: "高技能人才培训",
            showOnNavMenu: true,
          },
          component: () => import("@/views/serve/talentTraining/index.vue"),
        },
        {
          path: "serveEmpowerment",
          name: "serveEmpowerment",
          meta: {
            title: "专业性产业赋能",
            showOnNavMenu: true,
            dropDown: true,
          },
          redirect() {
            return { name: "reportWriting" };
          },
          children: [
            {
              path: "reportWriting",
              name: "reportWriting",
              meta: {
                title: "专业行业报告撰写",
                showOnNavMenu: true,
              },
              component: () =>
                import("@/views/serve/serveEmpowerment/reportWriting/index.vue"),
            },
            {
              path: "innovativeServices",
              name: "innovativeServices",
              meta: {
                title: "企业规划创新服务",
                showOnNavMenu: true,
              },
              component: () =>
                import(
                  "@/views/serve/serveEmpowerment/innovativeServices/index.vue"
                ),
            },
            {
              path: "specialServices",
              name: "specialServices",
              meta: {
                title: "科技发展专项服务",
                showOnNavMenu: true,
              },
              component: () =>
                import("@/views/serve/serveEmpowerment/specialServices/index.vue"),
            },
          ],
        },
      ],
    },
  ],
};
